/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import SendApplication from "./SendApplication";
import { Helmet } from "react-helmet-async";
import Layout from "../../../containers/Layouts/Layout";
import { gaSet } from "../../../services/googleAnalyticsService";
import JobContainer, { JobContainerProps } from "@/src/components/Jobs/Job/JobContainer";

const legalTraineeJobDetails: JobContainerProps = {
  title: "Rechtsreferendarin / Rechtsreferendar (m/w/d)",
  hardFacts: [
    {
      title: "Standort",
      value: "Köln, DE",
    },
    {
      title: "Arbeitsmodell",
      value: "Hybrid",
    },
    {
      title: "Bereich",
      value: "Operations",
    },
  ],
  content: [
    {
      type: "headline",
      headline: "für die Anwalts- oder Wahlstation",
    },
    {
      type: "text",
      text: "Legalbird Rechtsanwälte Rechtsanwalts GmbH - als Partnerkanzlei von Legalbird helfen wir unseren Mandanten einfach und effizient.",
    },
    {
      type: "text",
      text:
        "Durch unsere Expertise in den Bereichen Familienrecht, Verkehrsrecht, Vertragsrecht, Mietrecht und Arbeitsrecht und den Einsatz neuester Technologie, " +
        "helfen wir unseren Mandanten, ihre rechtlichen Fragestellungen sicher und schnell online zu lösen.",
    },
    {
      type: "headline",
      headline: "Was Deine Aufgaben sein werden",
    },
    {
      type: "list",
      items: [
        "Du übernimmst die Vorprüfung von neu eingehenden Mandaten im Vertragsrecht",
        "Du erstellst außergerichtliche und gerichtliche Schrift sätze im Vertragsrecht",
        "Du stehst in direktem Kontakt mit den Mandanten",
        "Du unterstützt bei der Konzeption und Ausarbeitung von Prozessen und neuen Rechtsbereichen für die Kanzlei und die Kooperation mit Legalbird",
      ],
    },
    {
      type: "headline",
      headline: "Was Du dazu brauchst",
    },
    {
      type: "list",
      items: [
        "Du hast das 1. Staatsexamen erfolgreich absolviert und suchst nun eine Herausforderung für deine Anwalts- oder Wahlstation",
        "Du denkst unternehmerisch und handelst pragmatisch, um für Deine Mandanten immer die bestmögliche Lösung zu finden",
        "Dich begeistert die Idee, Privatpersonen und Verbrauchern zu ihrem Recht zu verhelfen",
        "Du bist technologiebegeistert und arbeitest gerne und sehr versiert am PC und mit modernster Software",
      ],
    },
    {
      type: "headline",
      headline: "Was wir Dir bieten und was uns auszeichnet",
    },
    {
      type: "list",
      items: [
        "Einen flexiblen Arbeitsort vorwiegend mobil im Homeoffice mit Einarbeitung in unserem modernen Büro im Kranhaus im Kölner Rheinauhafen",
        "Eine überdurchschnittliche Vergütung",
        "Eine unternehmerische und anspruchsvolle Arbeit in einem motivierten und jungen Team",
        "Wir entscheiden und arbeiten sehr modern, automatisiert und mit vollem Fokus auf unsere Mandanten, um für diese das beste Ergebnis zu erzielen und ein ideales Kundenerlebnis zu bieten",
      ],
    },
  ],
  afterContent: <SendApplication />,
};

const LegalTrainee = () => {
  const title = "Jobs - Rechtsreferendarin / Rechtsreferendar | Legalbird";

  gaSet({ title: title });

  return (
    <Layout backgroundType={"landingpage"}>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <JobContainer {...legalTraineeJobDetails} />
    </Layout>
  );
};

export default LegalTrainee;
